export type SearchResultType = 'Product' | 'Variant' | 'Client' | 'Chart' | 'Chart Table';

export const SearchResultType: Record<SearchResultType, SearchResultType> = {
  Product: 'Product',
  Variant: 'Variant',
  Client: 'Client',
  Chart: 'Chart',
  'Chart Table': 'Chart Table',
};

export const SearchResultTypeLabel: Record<SearchResultType, string> = {
  Product: 'search.type.product',
  Variant: 'common.variant',
  Client: 'search.type.client',
  Chart: 'common.chart',
  'Chart Table': 'common.table-chart',
};

export interface SearchResult {
  thumbnail: string;
  title: string;
  subtitle: string;
  type: SearchResultType;
  link: string;
}
